import { ErrorBoundary } from "@sentry/react";
import React from "react";
import { RootStateOrAny, useSelector } from "react-redux";
import { ToastContainer } from "react-toastify";
import { ErrorMsg } from "../../components/AppMessages";
import { CedarShellLayout } from "../../components/Layouts";
import { ContactUsCard } from "./components/ContactUsCard";
import { DashboardSearchBar } from "./components/DashboardSearchBar";
import { QuickTourCard } from "./components/QuickTourCard";
import "./cedarHomeWelcome.scss";

export const CedarHome = () => {
  const userDetails = useSelector((state: RootStateOrAny) => state.user.details);
  const { first_name: firstName } = userDetails ?? {};

  return (
    <CedarShellLayout>
      <ErrorBoundary fallback={<ErrorMsg class={"formError"} />}>
        <div className="cedar_home_page">
          <div className="cedar_home_welcome" data-test-id="cedar-home-welcome">
            <h1 className="cedar_home_welcome_title">Hi {firstName || "there"}, welcome to CEDAR Home.</h1>

            <DashboardSearchBar />
          </div>

          <div className="cedar_home_cards_row">
            <ContactUsCard />

            <QuickTourCard />
          </div>
        </div>

        <ToastContainer
          position="top-right"
          autoClose={2500}
          hideProgressBar={true}
          newestOnTop={true}
          closeOnClick={true}
          draggable={false}
          pauseOnHover={false}
        />
      </ErrorBoundary>
    </CedarShellLayout>
  );
};
